import React from 'react';
import ChannelSelectorChannel from '../ChannelSelectorChannel';

const ChannelSelectorOption = (props) => {
  const { channel, onSelect } = props;

  const selectChannel = () => onSelect(channel);

  const onClick = selectChannel;
  const onKeyUp = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      selectChannel();
    }
  };

  return (
    <button onKeyUp={onKeyUp} onClick={onClick}>
      <ChannelSelectorChannel channel={channel} />
    </button>
  );
};

export default ChannelSelectorOption;
